import { SavedAccountsModalTranslations } from "./saved-accounts-modal-pt-br";

export const SAVED_ACCOUNTS_MODAL_FR_FR: SavedAccountsModalTranslations = {
	holderName: "Titulaire",
	agency: "Agence",
	accountNumber: "Compte",
	pixKey: "Clé PIX",
	addAccount: "Ajouter un compte",
	title: "Comptes enregistrés",
	search: "Rechercher un compte",
	return: "Retour",
	default: "Par défaut",
	edit: "Modifier",
	delete: "Supprimer",
};
